import { render, staticRenderFns } from "./list-scroll.vue?vue&type=template&id=363463b6&scoped=true"
import script from "./list-scroll.vue?vue&type=script&lang=js"
export * from "./list-scroll.vue?vue&type=script&lang=js"
import style0 from "./list-scroll.vue?vue&type=style&index=0&id=363463b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363463b6",
  null
  
)

export default component.exports